<template>
  <Container title="Precisamos da sua assinatura" :subtitle="subtitle" :noButton="true">
    <template #form>
      <template v-if="showFormAssinatura">
        <v-expand-transition>
          <SelectAssinatura @assinatura-saved="afterSaveAssinatura" />
        </v-expand-transition>
      </template>
      <template v-else>
        <v-expand-transition>
          <ShowAssinatura :assinatura="assinatura" @on-click-edit="showFormAssinatura = true" />
        </v-expand-transition>
        <div class="mt-10 text-center">
          <v-btn
            @click="submit"
            color="primary"
            class="secondary-font text-capitalize font-weight-bold py-7 mb-8"
            elevation="24"
            rounded
            x-large
            >Continuar</v-btn
          >
        </div>
      </template>
    </template>
  </Container>
</template>

<script>
import { mapGetters } from 'vuex'
import assinaturaService from '@/services/assinatura'
import Container from '@/modules/FichaClinica/FichaClinicaContainer'
import SelectAssinatura from '@/modules/Assinatura/SelectAssinatura'
import ShowAssinatura from '@/modules/Assinatura/ShowAssinatura'

export default {
  components: {
    Container,
    SelectAssinatura,
    ShowAssinatura
  },
  data: () => ({
    disableButton: false,
    assinatura: null,
    showFormAssinatura: true,
    subtitle: 'Atualize ou veja sua assinatura'
  }),
  computed: {
    ...mapGetters('user', ['urlLogo', 'colorTheme'])
  },
  methods: {
    submit() {
      const query = this.$route.query

      if (query.token || query.encryptedIdMapeamento) {
        this.$router.push({ path: '/avaliacao-psicossocial', query })
      } else {
        this.$router.push({ name: 'agendamentos' })
      }
    },
    async buscaAssinatura() {
      this.$showLoading()
      try {
        const { data } = await assinaturaService.buscaAssinatura()
        if (data.nova_assinatura) {
          this.assinatura = data.assinatura
          this.showFormAssinatura = false
        } else {
          this.subtitle = 'Atualize sua assinatura, escolha a que mais gostar'
        }
      } catch ({ response }) {
        this.$showErrorMessage(response.data.message)
      } finally {
        this.$hideLoading()
      }
    },
    async afterSaveAssinatura() {
      await this.buscaAssinatura()
      this.showFormAssinatura = false
    },
    applyThemeColor(color) {
      this.$vuetify.theme.themes.light.primary = color
    }
  },
  created() {
    const currentColor = this.colorTheme
    this.applyThemeColor(currentColor)
  },
  mounted() {
    this.buscaAssinatura()
  }
}
</script>
